/** Pages that show the cookie banner and the scroll-to-top button. */
const MARKETING_CHROME_PATHS = [
  '/',
  '/about',
  '/contact',
  '/privacy',
  '/terms',
  '/products',
  '/analysis-landing',
  '/financial-landing',
  '/integrations-landing',
  '/planning-landing',
] as const;

/** Pages that show the marketing footer. */
const FOOTER_LANDING_PATHS = [
  '/',
  '/about',
  '/contact',
  '/book-demo',
  '/privacy',
  '/terms',
  '/security',
  '/legal/msa',
  '/products',
  '/clients',
  '/blog',
  '/analysis-landing',
  '/financial-landing',
  '/integrations-landing',
  '/planning-landing',
  '/partners',
  '/newsletter',
  '/faq',
] as const;

function matchesPath(
  pathname: string | null | undefined,
  paths: readonly string[],
  mode: 'prefix' | 'segment'
): boolean {
  if (!pathname) return false;
  if (paths.includes(pathname)) return true;
  return paths.some(path => {
    if (path === '/') return false;
    if (mode === 'prefix') return pathname.startsWith(path);
    return pathname.startsWith(`${path}/`);
  });
}

export function isMarketingChromePath(
  pathname: string | null | undefined
): boolean {
  return matchesPath(pathname, MARKETING_CHROME_PATHS, 'prefix');
}

export function isFooterLandingPath(
  pathname: string | null | undefined
): boolean {
  return matchesPath(pathname, FOOTER_LANDING_PATHS, 'segment');
}
